<template>
  <el-row class="container_self">
        <h3>Adsense管理</h3>

        <el-row style="margin-bottom:20px"><el-button size="mini" type="danger" @click="addAdsense">新增Adsense账号</el-button></el-row>
        <el-row class="table_parent">
          <el-table :data="dataListL" v-loading="loading">
            <el-table-column prop="id" label="ID" align="center" width="50"></el-table-column>
            <el-table-column prop="account" label="Account" align="center"></el-table-column>
            <el-table-column prop="state" label="State" align="center"></el-table-column>
            <el-table-column label="Enabled" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.enabled==1">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="description" label="Description" align="center"></el-table-column>
            <el-table-column prop="createTime" label="CreateTime" align="center"></el-table-column>
            <el-table-column prop="refreshTokenExpiredTime" label="TokenExpiredTime" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="updateAdsense(scope.row)">更新</el-button>
                  <el-button size="mini" type="warning" @click="authAccount(scope.row.state)">刷新token</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>



        <el-dialog
          :title="string + ' Adsense 账号'"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
      <el-form
        :model="form"
        label-width="120px"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm search_parent"
      >
        <el-form-item label="Adsense账号">
          <el-input type="text" v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="应用名称">
          <el-input type="text" v-model="form.appName"></el-input>
        </el-form-item>
        <el-form-item label="授权文件地址">
          <el-input type="text" v-model="form.credentialsPath"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="text" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="唯一标识">
          <el-input type="text" v-model="form.state"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleAddForm" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </el-row>
</template>


<script>
 import {axiosGet,axiosPost} from '@/assets/ajaxFn'
  export default {
    data(){
      return{
        dataListL:[],
        loading:false,
        total:0,
        string:'新增',
        edit:false,
        dialogFormVisible:false,
        form:{
          account:"",
          appName:"",
          credentialsPath:"",
          description:"",
          state:""
        }
      }
    },
    methods:{
      addAdsense(){
        this.edit=false;
        this.string='新增';
        this.form={
          account:"",
          appName:"",
          credentialsPath:"",
          description:"",
          state:""
        };
        this.dialogFormVisible=true;
      },
     async getList(){
        this.loading=true;
       await axiosGet('/api/google/adsense/list').then(res=>{
          if(res.code==0){
            this.dataListL=res.data.records;
            this.total=res.data.total;
          }
        })
       this.loading=false;
      },
      submitForm(){
        let url=this.edit?'/api/google/adsense/update':"/api/google/adsense/add";
        axiosPost(url,this.form,'JSON').then(res=>{
          if(res.code==0){
            this.$message({message:this.edit?'更新成功':'添加成功',type:"success"})
            this.dialogFormVisible=false;
            this.getList();
          }
        })
      },
      updateAdsense(row){
        this.edit=true;
        this.string='更新';
        this.form.id=row.id;
        this.form.account=row.account;
        this.form.appName=row.appName;
        this.form.credentialsPath=row.credentialsPath;
        this.form.description=row.description;
        this.form.state=row.state;
        this.dialogFormVisible=true;
      },
      cancleAddForm(){
        this.dialogFormVisible=false;
        this.form={
          account:"",
          appName:"",
          credentialsPath:"",
          description:"",
          state:""
        }
      },
      authAccount(state){
        axiosGet('/api/google/auth/url?state='+state).then(res=>{
          if(res.code==0){
            window.open(res.data);
          }
        })
      }
    },
    mounted() {
      this.getList()
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/view/AdsenseManager/AdsenseList.vue